import { Helmet } from "react-helmet-async";
import { BRAND } from "@/lib/brand";

const SITE = process.env.REACT_APP_SITE_URL.replace(/\/$/, "");
const DEFAULT_OG = BRAND.logo;

export const Seo = ({ title, description, path = "/", type = "website", jsonLd, noindex = false, image }) => {
  const url = `${SITE}${path}`;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {noindex ? <meta name="robots" content="noindex, nofollow" /> : <meta name="robots" content="index, follow" />}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="OpenDegree" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image || DEFAULT_OG} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
};

export const breadcrumb = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({
    "@type": "ListItem", position: i + 1, name: it.name, item: `${SITE}${it.path}`,
  })),
});

export { SITE };
